export default __webpack_public_path__ + "static/media/regulatory--shared-path-bicycles-and-pedestrians--g1.72464b6b.png";